import { config } from "../../env";

export function authHeader(url, token) {
	// return authorization header with jwt token
	// uattestclient.dev.lexcare.in - localhost
	// ascent.lexcare.in
	// indegene.lexcare.in
	let port = window.location.origin.split("//")[1].split(":")[0];
	if (token) {
		if (token) {
			if (url.split("/")[3] !== "survey-collector") {
				return {
					Authorization: "Bearer " + token,
					"Content-Type": "application/json",
					source:
						port === "localhost"
							?config.SOURCE
							: window.location.origin?.split("//")[1],
				};
			} else {
				return {
					"Content-Type": "application/json",
					source:
						port === "localhost"
							?config.SOURCE
							: window.location.origin?.split("//")[1],
				};
			}
		} else {
			return {
				"Content-Type": "application/json",
				source:
					port === "localhost"
						?config.SOURCE
						: window.location.origin?.split("//")[1],
			};
		}
	} else {
		let access_token = localStorage.getItem("accessToken");
		// let urls = url.split('/')[3];

		if (access_token) {
			if (url.split("/")[3] !== "survey-collector") {
				return {
					Authorization: "Bearer " + access_token,
					"Content-Type": "application/json",
					source:
						port === "localhost"
							?config.SOURCE
							: window.location.origin?.split("//")[1],
				};
			} else {
				return {
					"Content-Type": "application/json",
					source:
						port === "localhost"
							?config.SOURCE
							: window.location.origin?.split("//")[1],
				};
			}
		} else {
			return {
				"Content-Type": "application/json",
				source:
					port === "localhost"
						?config.SOURCE
						: window.location.origin?.split("//")[1],
			};
		}
	}
}
